var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StepEventBranch"},_vm._l((_vm.stepEvents),function(stepEvent){return _c('StepEvent',{key:stepEvent.id,attrs:{"stepEvent":stepEvent}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }